import React, { useState } from "react";
import { Box, TextField, Button, Typography, Paper, InputAdornment, IconButton } from "@mui/material";
import { AccountCircle, Visibility, VisibilityOff, Lock } from "@mui/icons-material";
import { login } from "../services/api";
import { useNavigate } from "react-router-dom"; // ✅ Import useNavigate
const Login = () => {
   
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate(); // ✅ Initialize navigate function

    const handleLogin = async () => {
        try {
            console.log("Attempting login..."); // Debugging
            const response = await login({ email, password });
    
            if (response?.data?.token) { // ✅ Ensure response structure
                console.log("Login successful! Storing token...");
    
                localStorage.setItem("token", response.data.token);
                localStorage.setItem("user", JSON.stringify(response.data.user));
                console.log("Navigating now...");
                //navigate("/dashboard"); // ✅ Redirect after storing token
                window.location.href = "/dashboard";
            } else {
                console.error("Login failed: No token received");
                setError("Login failed: No token received");
            }
        } catch (err) {
            console.error("Login error:", err.response?.data || err);
            setError("Invalid email or password");
        }
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(135deg, #6e7864, #53574f)",
                padding: "20px"
            }}
        >
            <Paper elevation={10} sx={{ padding: 5, borderRadius: 3, maxWidth: 400, textAlign: "center",background: "linear-gradient(135deg, #6e7864, #53574f)", // 🍃 Softer gradient for the login box
        color: "#FFFFFF" }}>
                {/* Logo */}
                <img src="/logo.png" alt="NuGreen Logo" style={{ height: "150px", marginBottom: "20px" }} />

                {/* Title */}
                <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ color: "#D0D0D0" }}>
                    Partner Portal
                </Typography>

                {/* Error Message */}
                {error && <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>}

                {/* Email Input */}
                <TextField
    fullWidth
    label="Email"
    variant="outlined"
    margin="normal"
    value={email}
    onChange={(e) => setEmail(e.target.value)}
    InputProps={{
        startAdornment: (
            <InputAdornment position="start">
                <AccountCircle />
            </InputAdornment>
        ),
    }}
    sx={{
        "& .MuiOutlinedInput-root": {
            "& fieldset": { borderColor: "#B0B0B0" }, // Medium grey border
            "&:hover fieldset": { borderColor: "#A0A0A0" }, // Slightly darker grey on hover
            "&.Mui-focused fieldset": { borderColor: "#909090" }, // Even lighter grey when focused
        },
    }}
/>

                {/* Password Input */}
                <TextField
    fullWidth
    label="Password"
    type={showPassword ? "text" : "password"}
    variant="outlined"
    margin="normal"
    value={password}
    onChange={(e) => setPassword(e.target.value)}
    InputProps={{
        startAdornment: (
            <InputAdornment position="start">
                <Lock />
            </InputAdornment>
        ),
        endAdornment: (
            <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
            </InputAdornment>
        ),
    }}
    sx={{
        "& .MuiOutlinedInput-root": {
            "& fieldset": { borderColor: "#B0B0B0" }, // Medium grey border
            "&:hover fieldset": { borderColor: "#A0A0A0" }, // Slightly darker grey on hover
            "&.Mui-focused fieldset": { borderColor: "#909090" }, // Even lighter grey when focused
        },
    }}
/>

                {/* Login Button */}
                <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    sx={{
                        marginTop: "20px",
                        padding: "12px",
                        fontWeight: "bold",
                        background: "linear-gradient(135deg, #8aa172, #6e7864)"
                    }}
                    onClick={handleLogin}
                >
                    Login
                </Button>
                                {/* Register Link */}
                                <Typography variant="body2" sx={{ mt: 2, color: "#D0D0D0" }}>
                    Don't have an account?{" "}
                    <span
                        onClick={() => navigate("/register")}
                        style={{ cursor: "pointer", color: "#A0A0A0", fontWeight: "bold" }}
                    >
                        Register here
                    </span>
                </Typography>
            </Paper>
        </Box>
    );
};

export default Login;
